var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('edit',{attrs:{"module":_vm.module,"moduleId":_vm.id,"displayError":_vm.displayError},on:{"save":_vm.save,"draftSaved":function($event){_vm.unsavedDraft = false}}})}
var staticRenderFns = []

export { render, staticRenderFns }